<div (click)="presentJokerPopover($event)" class="joker" #jokerElement>
  <div [ngClass]="{ activated: jokerRingRound }" class="ring round">
    <div [ngClass]="{ activated: jokerRingSingle }" class="ring single">
      <fa-icon *ngIf="jokers?.length > 0" icon="smile-beam"></fa-icon>
      <fa-icon *ngIf="!jokers || jokers.length <= 0" icon="grin-beam-sweat"></fa-icon>
    </div>
  </div>
</div>
